/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import ImageLoader from 'react-render-image';
import LoadingSkeleton from '../loading-skeleton';
const ImageIcon = ({
  defaultIcon,
  testId,
  url,
  onError,
  onLoad
}) => jsx(ImageLoader, {
  src: url,
  loading: jsx(LoadingSkeleton, {
    testId: `${testId}-loading`
  }),
  loaded: jsx("img", {
    src: url,
    "data-testid": `${testId}-image`
  }),
  errored: defaultIcon,
  onError: onError,
  onLoad: onLoad
});
export default ImageIcon;